import React from "react"
import { faDollarSign } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DEFAULT_FORMATS, FORMAT_TYPE } from "src/utils/era-package"

export const summaryDetailFields = [
  { name: 'statementNumber', label: 'Statement Number', type: 'text' },
  { name: 'statementDate', label: 'Statement Print Date', type: 'date', dateFormats: DEFAULT_FORMATS.date },
  { name: 'importerNumber', label: 'Importer Number', type: 'text' },
  { name: 'port', label: 'Port', type: 'text' },
  { name: 'filerCode', label: 'Filer', type: 'text' },
  {
    name: 'statementTotal', label: 'Total Amount',
    type: 'text', formatter: FORMAT_TYPE.currency,
    icon: <FontAwesomeIcon icon={faDollarSign} />
  },
]
export const entryDetailFields = [
  { name: 'entryNumber', label: 'Entry Number', type: 'text' },
  ...summaryDetailFields
]

export const authFormFields = [{
  name: 'statementNumber', label: 'Statement Number',
  type: 'text', condition: () => false, defaultValue: ''
}, {
  name: 'statementType', label: 'Statement Type',
  type: 'auto', defaultValue: '',
}, {
  name: 'filerCode', label: 'Filer Code',
  type: 'text', defaultValue: '', maxLength: 3
}, {
  name: 'portCode', label: 'Port Code',
  type: 'text', defaultValue: '',
}, {
  name: 'payerUnitNumber', label: 'Payer\'s Unit Number',
  type: 'text', defaultValue: ''
}, {
  name: 'paymentAmount', label: 'Payment Amount',
  type: 'number', defaultValue: '', icon: <FontAwesomeIcon icon={faDollarSign} />
}, {
  type: 'new'
}, {
  name: 'isCancelPayment', label: 'Cancel Payment',
  type: 'toggle', defaultValue: false
}, {
  name: 'cancellationDate', label: 'Cancellation Date',
  type: 'date', defaultValue: ''
}]

export const dailyStatementFilters = [
  {
    name: 'global',
    label: 'Search across all columns',
    placeholder: 'Search across all columns',
    type: 'text',
    defaultValue: '',
    sizeProp: { xs: 12 }
  }, {
    name: 'statementNumber',
    label: 'Statement Number',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
  }, {
    name: 'relatedEntrySummary',
    label: 'Entry Summary Number',
    type: 'text',
    maxLength: 8,
    placeholder: '',
    defaultValue: ''
  }, {
    name: 'isFinalized',
    label: 'Statement Type',
    type: 'toggle',
    placeholder: '',
    toggleLabels: ['Preliminary', 'Final'],
    defaultValue: true
  }, {
    type: 'new'
  }, {
    name: 'statementDate',
    label: 'Statement Date',
    type: 'daterange'
  }, {
    name: 'receiveDate',
    label: 'Receive Date',
    type: 'daterange'
  }, {
    name: 'authorizationDate',
    label: 'Authorization Date',
    type: 'daterange'
  }, {
    type: 'new'
  }, {
    name: 'statementStatus',
    label: 'Statement Status',
    type: 'auto value'
  }, {
    name: 'authorizationStatus',
    label: 'Authorization Status',
    type: 'auto value'
  }
]

export const stmtUpdateFilters = [{
  name: 'stmtPrintDate',
  label: 'Statement Print Date',
  type: 'daterange'
}, {
  name: 'submitTime',
  label: 'Date Submitted',
  type: 'daterange'
}, {
  name: 'responseTime',
  label: 'Response Received Date',
  type: 'daterange'
}]
export const stmtUpdateFields = [
  { name: 'filerCode', label: 'Filer Code', type: 'text', maxLength: 3 },
  { name: 'entryNumber', label: 'Entry Number', type: 'text', },
  { name: 'port', label: 'Port of Entry', type: 'text', maxLength: 4 },
  { name: 'paymentType', label: 'Payment Type', type: 'auto', defaultValue: '' },
  { name: 'stmtPrintDate', label: 'Statement Date', type: 'date', dateFormats: DEFAULT_FORMATS.date },
  { name: 'stmtMonth', label: 'Periodic Statement Month', type: 'auto', defaultValue: '' },
  { name: 'clientBranch', label: 'Client Branch Designation', type: 'text', maxLength: 2 },
]

export const monthlyStatementFilters = [
  {
    name: 'global',
    label: 'Search across all columns',
    placeholder: 'Search across all columns',
    type: 'text',
    defaultValue: '',
    sizeProp: { xs: 12, sm: 7, md: 8 }
  }, {
    name: 'isFinalized',
    label: 'Statement Type',
    type: 'toggle',
    placeholder: '',
    toggleLabels: ['Preliminary', 'Final'],
    defaultValue: true,
    sizeProp: { xs: 12, sm: 5, md: 4 }
  }, {
    type: 'new'
  }, {
    name: 'pmsPrintDate',
    label: 'Print Date',
    type: 'daterange'
  }, {
    name: 'pmsDueDate',
    label: 'Due Date',
    type: 'daterange'
  }, {
    name: 'receiveDate',
    label: 'Receive Date',
    type: 'daterange'
  }
]
export const monthlyDetailFields = [
  { name: 'pmsNumber', label: 'Statement Number', type: 'text' },
  { name: 'pmsFiler', label: 'Filer', type: 'text' },
  { name: 'pmsImporter', label: 'Importer Number', type: 'text' },
  { name: 'pmsPrintDate', label: 'Statement Print Date', type: 'date', dateFormats: DEFAULT_FORMATS.date },
  { name: 'pmsDueDate', label: 'Statement Due Date', type: 'date', dateFormats: DEFAULT_FORMATS.date },
  {
    name: 'pmsTotal', label: 'Total Amount',
    type: 'text', formatter: FORMAT_TYPE.currency,
    icon: <FontAwesomeIcon icon={faDollarSign} />
  },
]